export class VnaCallerIdSelected {
    private pk: number;

    constructor(pk: number) {
        this.pk = pk;
    }

    getPk(): number {
        return this.pk;
    }
}


// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/caller-id/model/VnaCallerIdSelected.ts